import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DeployedYear, DropdownMonthList, EmptyString, InsertDateFormat } from "utils/Constant";
import { ApiGetPaymentReceived, ApiGetTransactionReportEdc, ApiUpdatePaymentReceived } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { money } from "utils/helpers";
import moment from "moment";
import DatePicker from "components/Input/DatePicker";
import SaveButton from "components/Button/SaveButton";
import CheckCircleIcon from "assets/icon/CheckCircleIcon";
import HideIcon from "assets/icon/HideIcon";
import ShowIcon from "assets/icon/ShowIcon";
import SaveIcon from "assets/icon/SaveIcon";
import Dropdown from "components/Input/Dropdown";
import SearchButton from "components/Button/SearchButton";

export default function PaymentReceived(){
    const { fetch: getTransactionList } = useFetch(ApiGetPaymentReceived)
    const { fetch: updatePaymentReceived } = useFetch(ApiUpdatePaymentReceived)
    const { fetch: getEdc } = useFetch(ApiGetTransactionReportEdc)
        
    const [date, setDate] = useState(new Date())
    const [transactionList, setTransactionList] = useState([])
    const [showSalesDetail, setShowSalesDetail] = useState(false)
    const [showNettQrisDetail, setShowNettQrisDetail] = useState(true)
    const [groupByOptions, setGroupByOptions] = useState([
        { label: "EDC", value: "edc" },
        { label: "Day", value: "day" },
    ])
    const [groupBy, setGroupBy] = useState("day")
    const [transactionDate, setTransactionDate] = useState(new Date())
    const [edcOptions, setEdcOptions] = useState([])
    const [edcId, setEdcId] = useState("")
    const [monthOptions, setMonthOptions] = useState(DropdownMonthList)
    const [month, setMonth] = useState(moment(new Date()).format("MM"))
    const [year, setYear] = useState(moment(new Date()).format("YYYY"))
    const [yearOptions, setYearOptions] = useState([])

    // const firstDate = new Date(year, month - 1, 1);
    // const lastDate = new Date(year, month, 0); // 0th day of next month = last day of current month

    const getYearOptions = () => {
        let startYear = parseInt(DeployedYear)
        let thisYear = parseInt(moment(new Date()).format("yyyy"))

        let tempArray = []
        for (let i = startYear; i <= thisYear; i++){
            tempArray.push( {label: String(i), value: String(i)} )
        }

        setYearOptions(tempArray)
    }
    // Event Handlers
    
    const dateChange = (e) => {
        if (e === null) {
            setDate(new Date())
        }else{
            setDate(e)
        }
    }
    const paymentReceivedChange = (index, key, value) => {
        const newData = [...transactionList];
        newData[index][key] = money(value);
        setTransactionList(newData);
    }
    const groupByChange = (e) => {
        setGroupBy(e.value)
    }

    const saveBtnClick = (edcId, date, paymentReceived) => {
        setLoading({isOpen: true})

        fUpdatePaymentReceived(edcId, date, paymentReceived).then(() => {
            setLoading({isOpen: false})
        })
    }
    const matchBtnClick = (trxDate, nettoOnUs, nettoOffUs, nettoQrisOnUs, nettoQrisOffUs, edcId, index, key) => {        
        let paymentReceived = String(Math.floor(parseFloat(nettoOffUs)) + Math.floor(parseFloat(nettoOnUs)) + Math.floor(parseFloat(nettoQrisOnUs)) + Math.floor(parseFloat(nettoQrisOffUs)))

        setLoading({isOpen: true})

        fUpdatePaymentReceived(edcId, trxDate, paymentReceived).then(() => {
            // const newData = [...transactionList];
            // newData[index][key] = money(paymentReceived);
            // setTransactionList(newData);

            setTransactionList(prev =>
                prev.map(item =>
                item.edcId === edcId
                    ? { ...item, paymentReceived: paymentReceived }
                    : item
                )
            );

            setLoading({isOpen: false})
        })
    }
    const searchClick = () => {
        if (edcId !== EmptyString){
            setLoading({isOpen: true})

            fGetTransactionList(date).then(() => {
                setLoading({isOpen: false})
            })
        }
        
    }
    const showSalesDetailClick = () => {
        setShowSalesDetail(!showSalesDetail)
    }
    const showNettQrisDetailClick = () => {
        setShowNettQrisDetail(!showNettQrisDetail)
    }

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        setLoading({isOpen: true})
        
        if (groupBy === "edc"){
            getYearOptions()
            fGetEdcList()
            setTransactionList([])

            if (edcId !== ""){
                fGetTransactionList(date).then(() => {
                    setLoading({isOpen: false})
                })
            } else {
                setLoading({isOpen: false})
            }
        } else {
            fGetTransactionList(date).then(() => {
                setLoading({isOpen: false})
            })
        }
    },[date, groupBy])

    // Function Api Call
    async function fGetTransactionList(date){
        let dateFrom = moment(date).format(InsertDateFormat)
        let dateTo = moment(date).format(InsertDateFormat)

        if (groupBy === "edc"){
            dateFrom = new Date(year, month - 1, 1)
            dateTo = new Date(year, month, 0)
        }   

        await getTransactionList({
            data: {
                dateFrom: moment(dateFrom).format(InsertDateFormat),
                dateTo: moment(dateTo).format(InsertDateFormat),
                groupBy: groupBy,
                edcId: edcId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setTransactionList(response.data)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdatePaymentReceived(edcId, transactionDate, paymentReceived){
        await updatePaymentReceived({
            data: {
                edcId: edcId,
                transactionDate: moment(transactionDate).format(InsertDateFormat), 
                paymentReceived: paymentReceived.replaceAll(",", "")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            setSuccessModal({isOpen: false})
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetEdcList(){
        await getEdc({
            data: {
                dateFrom: moment(new Date(year, month - 1, 1)).format(InsertDateFormat),
                dateTo: moment(new Date(year, month, 0)).format(InsertDateFormat),
                status: "1"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data
                let tempArray = []

                tempArray.push({label: "All", value: EmptyString})

                for (let i = 0; i < data.length; i++){
                    tempArray.push({ label: data[i].bankCode + " - " + data[i].edcName, value: String(data[i].edcId) })
                }

                setEdcOptions(tempArray)
                setEdcId(edcId)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    function fCheckPaymentReceived(nettoOnUs, nettoOffUs, nettoQrisOnUs, nettoQrisOffUs, paymentReceived){
        let onUs = Math.floor(parseFloat(nettoOnUs))
        let offUs = Math.floor(parseFloat(nettoOffUs))
        let qrisOnUs = Math.floor(parseFloat(nettoQrisOnUs))
        let qrisOffUs = Math.floor(parseFloat(nettoQrisOffUs))
        let payment = Math.floor(parseFloat(paymentReceived))

        let totalNetto = onUs + offUs + qrisOnUs + qrisOffUs

        if (totalNetto == payment){
            return true
        }else{
            return false
        }
    }

    return(
        <div className="flex flex-col gap-2 mb-12 sm:mb-0">
            <div >
                <span className="font-semibold text-2xl">Payment Received</span>
            </div>
            <hr />

            <div className="hidden sm:flex gap-4 items-center">
                <span className="font-semibold text-lg">Group By</span>
                <Dropdown className="w-24" options={groupByOptions} value={groupBy} onChange={groupByChange} />
            </div>

            {groupBy === "edc" && (
                <div>
                    <div className="flex gap-2">
                        <div className="flex flex-col gap-2">
                            <span>Month</span>
                            <Dropdown className="w-72" options={monthOptions} value={month} onChange={(e) => setMonth(e.value)} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <span>Year</span>
                            <Dropdown className="w-36" options={yearOptions} value={year} onChange={(e) => setYear(e.value)} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <span>EDC</span>
                            <Dropdown className="w-72" options={edcOptions} value={edcId} onChange={(e) => setEdcId(e.value)} placeholder="Select EDC" />
                        </div>
                        <div className="flex flex-col gap-2">
                            <span>&nbsp;</span>
                            <SearchButton onClick={searchClick} />
                        </div>
                    </div>

                    <div className="hidden xl:block mt-3">
                        <table className="w-full border bg-white text-md font-light mt-4">
                            <thead>
                                <tr className="h-12">
                                    <th className="font-semibold w-16">No</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell w-32">Tanggal</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell">Total Sales</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. On Us</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. Off Us</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. Qris On Us</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. Qris Off Us</th>
                                    <th className="font-semibold text-left px-2">N. On Us</th>
                                    <th className="font-semibold text-left px-2">N. Off Us</th>
                                    <th className={`font-semibold text-left px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>N. Qris On Us</th>
                                    <th className={`font-semibold text-left px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>N. Qris Off Us</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell">Total Netto</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell">Payment Received</th>
                                    <th className="font-semibold text-center px-2 w-28">Action</th>
                                </tr>
                            </thead>
                            {transactionList?.length > 0 ? 
                                <tbody className="border">
                                    {transactionList?.map((data, i) => {
                                        return(
                                            <tr className={`my-2 row h-10 border-y hover:opacity-80 ${ fCheckPaymentReceived(data.nettoOnUs, data.nettoOffUs, data.nettoQrisOnUs, data.nettoQrisOffUs, data.paymentReceived) ? 'bg-yellow-400' : 'bg-gray-100' }`} key={ i }>
                                                <td className="text-center">{ data.rowNumber }</td>
                                                <td className="px-2">
                                                    <span>{ moment(data.transactionDate).format('DD MMM yyyy') }</span>
                                                </td>
                                                <td className="px-2">
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolume)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeOnUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeOffUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeQrisOnUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeQrisOffUs)))) }</span>
                                                </td>
                                                <td className="px-2">
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoOnUs)))) }</span>
                                                </td>
                                                <td className="px-2">
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoOffUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoQrisOnUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoQrisOffUs)))) }</span>
                                                </td>
                                                <td className="px-2 font-semibold">
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoOffUs)) + Math.floor(parseFloat(data.nettoOnUs)) + Math.floor(parseFloat(data.nettoQrisOnUs)) + Math.floor(parseFloat(data.nettoQrisOffUs)))) }</span>
                                                </td>
                                                <td className="px-2 py-1">
                                                    <input className="border px-4 py-2 rounded w-[180px]" value={money(data.paymentReceived)} onChange={(e) => {paymentReceivedChange(i, 'paymentReceived', e.target.value)}}></input>
                                                </td>
                                                <td className="">
                                                    <div className="flex gap-2 justify-center">
                                                        <button className="flex items-center gap-2 bg-black rounded-md px-2 py-2" 
                                                            onClick={() => {matchBtnClick(data.transactionDate, data.nettoOnUs, data.nettoOffUs, data.nettoQrisOnUs, data.nettoQrisOffUs, data.edcId, i, 'paymentReceived')}}>
                                                            <CheckCircleIcon className="fill-white w-6" />
                                                        </button>
                                                        <button className="flex items-center bg-black rounded-md px-2 py-2" onClick={(e) => saveBtnClick(data.edcId, data.transactionDate, data.paymentReceived)} >
                                                            <SaveIcon className="fill-white w-6" />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            :
                                <tbody>
                                    <tr>
                                        <td className="text-center" colSpan={12}>
                                            <span>No Transaction Data</span>
                                        </td>
                                    </tr>
                                </tbody>
                            }
                        </table>
                    </div>
                </div>
            )}

            {groupBy === "day" && (
                <div>
                    <div className="flex flex-col sm:flex-row gap-5 mt-2 sm:mt-5">
                        <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
                            <div className="flex flex-col gap-2 w-42">
                                <span>Date</span>
                                <DatePicker className="w-full h-10 bg-white" value={date} onChange={dateChange} />
                            </div>
                        </div>
                    </div>

                    <div className="hidden sm:flex mt-5 gap-2 justify-end">
                        <button className="px-4 py-2 bg-black rounded-md flex gap-2" onClick={showSalesDetailClick}>
                            {showSalesDetail ? 
                                <HideIcon />
                                :
                                <ShowIcon className="fill-white w-6" />
                            }
                            <span className="text-white">{showSalesDetail ? 'Sales Detail' : 'Sales Detail'}</span>
                        </button>
                        <button className="px-4 py-2 bg-black rounded-md flex gap-2" onClick={showNettQrisDetailClick}>
                            {showNettQrisDetail ? 
                                <HideIcon />
                                :
                                <ShowIcon className="fill-white w-6" />
                            }
                            <span className="text-white">{showSalesDetail ? 'Nett Qris Detail' : 'Nett Qris Detail'}</span>
                        </button>
                    </div>
                            
                    {/* WEB VIEW */}
                    <div className="hidden xl:block mt-3">
                        <table className="w-full border bg-white text-md font-light mt-4">
                            <thead>
                                <tr className="h-12">
                                    <th className="font-semibold w-16">No</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell w-[260px]">EDC Name</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell">Total Sales</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. On Us</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. Off Us</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. Qris On Us</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. Qris Off Us</th>
                                    <th className="font-semibold text-left px-2">N. On Us</th>
                                    <th className="font-semibold text-left px-2">N. Off Us</th>
                                    <th className={`font-semibold text-left px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>N. Qris On Us</th>
                                    <th className={`font-semibold text-left px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>N. Qris Off Us</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell">Total Netto</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell">Payment Received</th>
                                    <th className="font-semibold text-center px-2 w-28">Action</th>
                                </tr>
                            </thead>
                            {transactionList?.length > 0 ? 
                                <tbody className="border">
                                    {transactionList?.map((data, i) => {
                                        return(
                                            <tr className={`my-2 row h-10 border-y hover:opacity-80 ${ fCheckPaymentReceived(data.nettoOnUs, data.nettoOffUs, data.nettoQrisOnUs, data.nettoQrisOffUs, data.paymentReceived) ? 'bg-yellow-400' : 'bg-gray-100' }`} key={ i }>
                                                <td className="text-center">{ data.rowNumber }</td>
                                                <td className="px-2">
                                                    <span>{ data.bankCode + " - " + data.edcName }</span>
                                                </td>
                                                <td className="px-2">
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolume)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeOnUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeOffUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeQrisOnUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeQrisOffUs)))) }</span>
                                                </td>
                                                <td className="px-2">
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoOnUs)))) }</span>
                                                </td>
                                                <td className="px-2">
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoOffUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoQrisOnUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoQrisOffUs)))) }</span>
                                                </td>
                                                <td className="px-2 font-semibold">
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoOffUs)) + Math.floor(parseFloat(data.nettoOnUs)) + Math.floor(parseFloat(data.nettoQrisOnUs)) + Math.floor(parseFloat(data.nettoQrisOffUs)))) }</span>
                                                </td>
                                                <td className="px-2 py-1">
                                                    <input className="border px-4 py-2 rounded w-[180px]" value={money(data.paymentReceived)} onChange={(e) => {paymentReceivedChange(i, 'paymentReceived', e.target.value)}}></input>
                                                </td>
                                                <td className="">
                                                    <div className="flex gap-2 justify-center">
                                                        <button className="flex items-center gap-2 bg-black rounded-md px-2 py-2" 
                                                            onClick={() => {matchBtnClick(data.transactionDate, data.nettoOnUs, data.nettoOffUs, data.nettoQrisOnUs, data.nettoQrisOffUs, data.edcId, i, 'paymentReceived')}}>
                                                            <CheckCircleIcon className="fill-white w-6" />
                                                        </button>
                                                        <button className="flex items-center bg-black rounded-md px-2 py-2" onClick={(e) => saveBtnClick(data.edcId, data.transactionDate, data.paymentReceived)} >
                                                            <SaveIcon className="fill-white w-6" />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            :
                                <tbody>
                                    <tr>
                                        <td className="text-center" colSpan={12}>
                                            <span>No Transaction Data</span>
                                        </td>
                                    </tr>
                                </tbody>
                            }
                        </table>
                    </div>
                    
                    {/* MOBILE VIEW */}
                    <div className="xl:hidden mt-5">
                        {transactionList?.length > 0 ? 
                            <div className="flex flex-col gap-2">
                                {transactionList?.map((data, i) => {
                                    return(
                                        <div className={`p-2 border rounded-md flex justify-between items-center ${
                                                parseInt(data.paymentReceived) === parseInt(data.nettoOnUs) + parseInt(data.nettoOffUs) + parseInt(data.nettoQrisOnUs) + parseInt(data.nettoQrisOffUs)
                                                ? 'bg-yellow-400' : ''
                                            }`}>
                                            <div className="flex flex-col">
                                                <label>{data.bankCode + " - " + data.edcName}</label>
                                                <label className="font-semibold">Netto : Rp { money(String(Math.floor(parseFloat(data.nettoOffUs)) + Math.floor(parseFloat(data.nettoOnUs)) + Math.floor(parseFloat(data.nettoQrisOnUs)) + Math.floor(parseFloat(data.nettoQrisOffUs)))) }</label>
                                            </div>

                                            <div className="">
                                                <button className="flex items-center gap-2 bg-black rounded-md px-2 py-2" 
                                                    onClick={() => {matchBtnClick(data.transactionDate, data.nettoOnUs, data.nettoOffUs, data.nettoQrisOnUs, data.nettoQrisOffUs, data.edcId, i, 'paymentReceived')}}>
                                                    <CheckCircleIcon className="fill-white w-6" />
                                                </button>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        :
                            <div>
                                <span>No Transaction Data</span>
                            </div>
                        }
                    </div>
                </div>
            )}

            {groupBy === "edc" && (
                <div>
                    <span>Group by EDC is under development.</span>
                </div>
            )}
            

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}